import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import '@angular/common/locales/global/it';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgxStripeModule } from 'ngx-stripe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

//Api modules
import { ApiModule as NgAuthApiModule } from 'auth-api';
import { ApiModule as NgStdApiModule } from 'std-api';
import { ApiModule as NgProfileApiModule } from 'profile-api';
import { ApiModule as NgTenderApiModule } from 'tender-api';
import { ApiModule as NgParticipationApiModule } from 'participation-api';
import { ApiModule as NgQuestionApiModule } from 'question-api';
import { ApiModule as NgSharingApiModule } from 'sharing-api';
import { ApiModule as NgDesignerApiModule } from 'designer-api';
import { ApiModule as NgShowcaseApiModule } from 'showcase-api';
import { ApiModule as NgFeedbackApiModule } from 'feedback-api';
import { ApiModule as NgAnnouncementApiModule } from 'announcement-api';
import { ApiModule as NgAnnouncementOfferApiModule } from 'announcement-offer-api';

import { BASE_PATH as NG_AUTH_API_BASE_PATH } from 'auth-api';
import { BASE_PATH as NG_STD_API_BASE_PATH } from 'std-api';
import { BASE_PATH as NG_PROFILE_API_BASE_PATH } from 'profile-api';
import { BASE_PATH as NG_TENDER_API_BASE_PATH } from 'tender-api';
import { BASE_PATH as NG_PARTICIPATION_API_BASE_PATH } from 'participation-api';
import { BASE_PATH as NG_QUESTION_API_BASE_PATH } from 'question-api';
import { BASE_PATH as NG_SHARING_API_BASE_PATH } from 'sharing-api';
import { BASE_PATH as NG_DESIGNER_API_BASE_PATH } from 'designer-api';
import { BASE_PATH as NG_SHOWCASE_API_BASE_PATH } from 'showcase-api';
import { BASE_PATH as NG_FEEDBACK_API_BASE_PATH } from 'feedback-api';
import { BASE_PATH as NG_ANNOUNCEMENT_API_BASE_PATH } from 'announcement-api';
import { BASE_PATH as NG_ANNOUNCEMENT_OFFER_API_BASE_PATH } from 'announcement-offer-api';


//Components
import { LoginComponent } from './login/login.component';
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { LogoutComponent } from './logout/logout.component';
import { ProfileComponent } from './profile/profile.component';
import { RegistrationThanksComponent } from './registration-thanks/registration-thanks.component';
import { ReservedAreaComponent } from './reserved-area/reserved-area.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { NewTenderComponent } from './new-tender/new-tender.component';
import { NewClusterTenderComponent } from './new-cluster-tender/new-cluster-tender.component';
import { BuyNewClusterTenderComponent } from './buy-new-cluster-tender/buy-new-cluster-tender.component';
import { BuyNewTenderComponent } from './buy-new-tender/buy-new-tender.component';
import { BuyNewTenderThanksComponent } from './buy-new-tender-thanks/buy-new-tender-thanks.component';
import { TendersComponent } from './tenders/tenders.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalComponent } from './modal/modal.component';
import { TenderDetailComponent } from './tender-detail/tender-detail.component';
import { QuestionsAndAnswersComponent } from './questions-and-answers/questions-and-answers.component';
import { OngoingTendersComponent } from './ongoing-tenders/ongoing-tenders.component';
import { BuyTenderParticipationComponent } from './buy-tender-participation/buy-tender-participation.component';
import { BuyTenderParticipationThanksComponent } from './buy-tender-participation-thanks/buy-tender-participation-thanks.component';
import { ParticipationDetailComponent } from './participation-detail/participation-detail.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { PrepaidPacketsComponent } from './prepaid-packets/prepaid-packets.component';
import { BuyPrepaidPacketComponent } from './buy-prepaid-packet/buy-prepaid-packet.component';
import { BuyPrepaidPacketThanksComponent } from './buy-prepaid-packet-thanks/buy-prepaid-packet-thanks.component';
import { AcceptInvitationComponent } from './accept-invitation/accept-invitation.component';
import { ReservedAreaAccessDeniedComponent } from './reserved-area-access-denied/reserved-area-access-denied.component';
import { InvalidControlScrollDirective } from './ng-invalid-control-scroll-wt-directive.directive';
import { QuoteRequestComponent } from './quote-request/quote-request.component';
import { BuyQuoteRequestComponent } from './buy-quote-request/buy-quote-request.component';
import { BuyQuoteRequestThanksComponent } from './buy-quote-request-thanks/buy-quote-request-thanks.component';
import { BuyUpgradeComponent } from './buy-upgrade/buy-upgrade.component';
import { BuyUpgradeErrorComponent } from './buy-upgrade-error/buy-upgrade-error.component';
import { ShowcaseCompanyComponent } from './showcase-company/showcase-company.component';
import { ShowcaseProfessionalComponent } from './showcase-professional/showcase-professional.component';
import { ArrayPipe } from './array.pipe';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackThanksComponent } from './feedback-thanks/feedback-thanks.component';
import { FeedbackErrorComponent } from './feedback-error/feedback-error.component';
import { FeedbackRigoreComponent } from './feedback-rigore/feedback-rigore.component';
import { FeedbackQualitaComponent } from './feedback-qualita/feedback-qualita.component';
import { FeedbackProfessionalitaComponent } from './feedback-professionalita/feedback-professionalita.component';
import { FeedbackSicurezzaComponent } from './feedback-sicurezza/feedback-sicurezza.component';
import { FeedbackOrdineComponent } from './feedback-ordine/feedback-ordine.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { AnnouncementDetailComponent } from './announcement-detail/announcement-detail.component';
import { ShowcaseAnnouncementComponent } from './showcase-announcement/showcase-announcement.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LostPasswordComponent,
    ResetPasswordComponent,
    LogoutComponent,
    ConfirmEmailComponent,
    ProfileComponent,
    RegistrationThanksComponent,
    ReservedAreaComponent,
    DashboardComponent,
    PaymentMethodsComponent,
    NewTenderComponent,
    NewClusterTenderComponent,
    BuyNewTenderComponent,
    BuyNewClusterTenderComponent,
    BuyNewTenderThanksComponent,
    TendersComponent,
    ModalComponent,
    TenderDetailComponent,
    QuestionsAndAnswersComponent,
    OngoingTendersComponent,
    BuyTenderParticipationComponent,
    BuyTenderParticipationThanksComponent,
    ParticipationDetailComponent,
    PrepaidPacketsComponent,
    BuyPrepaidPacketComponent,
    BuyPrepaidPacketThanksComponent,
    AcceptInvitationComponent,
    ReservedAreaAccessDeniedComponent,
    InvalidControlScrollDirective,
    QuoteRequestComponent,
    BuyQuoteRequestComponent,
    BuyQuoteRequestThanksComponent,
    BuyUpgradeComponent,
    BuyUpgradeErrorComponent,
    ShowcaseCompanyComponent,
    ShowcaseProfessionalComponent,
    ArrayPipe,
    FeedbackComponent,
    FeedbackThanksComponent,
    FeedbackErrorComponent,
    FeedbackRigoreComponent,
    FeedbackQualitaComponent,
    FeedbackProfessionalitaComponent,
    FeedbackSicurezzaComponent,
    FeedbackOrdineComponent,
    AnnouncementsComponent,
    AnnouncementDetailComponent,
    ShowcaseAnnouncementComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgAuthApiModule,
    NgStdApiModule,
    NgProfileApiModule,
    NgTenderApiModule,
    NgParticipationApiModule,
    NgQuestionApiModule,
    NgSharingApiModule,
    NgDesignerApiModule,
    NgShowcaseApiModule,
    NgFeedbackApiModule,
    NgAnnouncementApiModule,
    NgAnnouncementOfferApiModule,
    //NgxStripeModule.forRoot('pk_test_AMj1AZCibUW1R8Wr5MWk8Q0A00jkTDLk72'),
    NgxStripeModule.forRoot('pk_live_51HO3MVHDnSD0ZerkdMrKEuZjB3I9w1iY3o3v6ad6cSI21HmhfotncPD7xAYzNePugsI5SQS7cl7fHEoCR7UBdbxv00j5p1D3Ag'),
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  // providers: [{provide: NG_AUTH_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_STD_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_PROFILE_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_TENDER_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_PARTICIPATION_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_QUESTION_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_SHARING_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_DESIGNER_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_SHOWCASE_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_FEEDBACK_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_ANNOUNCEMENT_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             {provide: NG_ANNOUNCEMENT_OFFER_API_BASE_PATH, useValue: 'http://LOCALHOST:8080/app/rest-1.0'},
  //             MatDatepickerModule,
  //             MatNativeDateModule,
  //             {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
  //             {provide: LOCALE_ID, useValue: 'it' },
  //             InvalidControlScrollDirective
  //            ],
  providers: [{ provide: NG_AUTH_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_STD_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_PROFILE_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_TENDER_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_PARTICIPATION_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_QUESTION_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_SHARING_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_DESIGNER_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_SHOWCASE_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_FEEDBACK_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_ANNOUNCEMENT_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
  { provide: NG_ANNOUNCEMENT_OFFER_API_BASE_PATH, useValue: 'https://backoffice.skimmingitalia.it/app/rest-1.0' },
    MatDatepickerModule,
    MatNativeDateModule,
  { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
  { provide: LOCALE_ID, useValue: 'it' },
    InvalidControlScrollDirective
  ],
  // providers: [{ provide: NG_AUTH_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_STD_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_PROFILE_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_TENDER_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_PARTICIPATION_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_QUESTION_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_SHARING_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_DESIGNER_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_SHOWCASE_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_FEEDBACK_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_ANNOUNCEMENT_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  // { provide: NG_ANNOUNCEMENT_OFFER_API_BASE_PATH, useValue: 'https://test.backoffice.skimmingitalia.it/app/rest-1.0' },
  //   MatDatepickerModule,
  //   MatNativeDateModule,
  // { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
  // { provide: LOCALE_ID, useValue: 'it' },
  //   InvalidControlScrollDirective
  // ],

  bootstrap: [AppComponent]
})
export class AppModule { }
